import { render, staticRenderFns } from "./ActDetails.vue?vue&type=template&id=e8fb2f18"
import script from "./ActDetails.vue?vue&type=script&lang=js"
export * from "./ActDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports